import ColorThief, { Color } from 'color-thief-browser';

import Model from '../Model';
import stringToColor from '../utils/stringToColor';
import ItemList from '../utils/ItemList';
import computed from '../utils/computed';
import GroupBadge from '../components/GroupBadge';
import Mithril from 'mithril';
import Group from './Group';
import Tag from 'flarum/tags/models/Tag';

export default class ActivityTag extends Model {
  tagObj() {
    return Model.hasOne<Tag | null>('tag').call(this);
  }
  tag() {
    return Model.attribute<number>('tagId').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  slug() {
    return Model.attribute<string>('slug').call(this);
  }
  description() {
    return Model.attribute<string>('description').call(this);
  }
  uniqueKey() {
    return Model.attribute<string>('uniqueKey').call(this);
  }
}
